import React, { useState, useEffect } from 'react';
import '../../App.css';
import './CoffeeRoaster.css';
import './OurCoffee.css';
import './Merch.css';
import Footer from '../Footer';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useCart } from '../../contexts/CartContext';

const images = [
    '/images/tshirt1-web.jpg',
    '/images/tshirt2-web.jpg',
];

const SIZES = ['XL', 'XXL'];
const PRICE = 35;

export default function Merch() {
    const [activeIndex, setActiveIndex] = useState(0);
    const [selectedSize, setSelectedSize] = useState('');
    const [quantity, setQuantity] = useState(1);
    const { addToCart, openDrawer } = useCart();

    useEffect(() => {
        document.title = 'OFFF THE ROAST Tee — Merch | OFFF THE ROAST';
    }, []);

    const goLeft = () => {
        setActiveIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const goRight = () => {
        setActiveIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    const handleAddToCart = () => {
        if (!selectedSize) return;
        addToCart({
            type: 'merch',
            productId: 'tshirt',
            name: 'OFFF THE ROAST Tee',
            color: 'Black',
            size: selectedSize,
            quantity,
            unitPrice: PRICE,
        });
        openDrawer();
    };

    return (
        <>
            <div className='equip-page'>
                <div className='equip-container'>
                    {/* Left: Image Gallery */}
                    <div className='equip-gallery'>
                        <div className='equip-main-image'>
                            <button className='equip-arrow equip-arrow-left' onClick={goLeft}>
                                <FaChevronLeft />
                            </button>
                            <img src={images[activeIndex]} alt='OFFF THE ROAST Tee' />
                            <button className='equip-arrow equip-arrow-right' onClick={goRight}>
                                <FaChevronRight />
                            </button>
                        </div>
                        <div className='equip-thumbnails'>
                            {images.map((img, idx) => (
                                <div
                                    key={idx}
                                    className={`equip-thumb ${idx === activeIndex ? 'equip-thumb-active' : ''}`}
                                    onClick={() => setActiveIndex(idx)}
                                >
                                    <img src={img} alt={`Thumbnail ${idx + 1}`} />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right: Product Info */}
                    <div className='equip-info'>
                        <h1 className='equip-product-name'>OFFF THE ROAST Tee</h1>
                        <p className='equip-product-subtitle'>Premium cotton crewneck with signature roast print</p>
                        <p className='equip-product-price'>${PRICE} <span className='equip-currency'>USD</span></p>

                        <div className='equip-color-section'>
                            <span className='equip-color-label'>Color: Black</span>
                            <div className='equip-color-options'>
                                <div
                                    className='equip-color-swatch equip-swatch-black merch-swatch-active'
                                    title='Black'
                                />
                            </div>
                        </div>

                        <div className='equip-color-section'>
                            <span className='equip-color-label'>Size: {selectedSize || 'Select a size'}</span>
                            <div className='merch-size-options'>
                                {SIZES.map((s) => (
                                    <button
                                        key={s}
                                        className={`merch-size-btn ${selectedSize === s ? 'merch-size-selected' : ''}`}
                                        onClick={() => setSelectedSize(s)}
                                    >
                                        {s}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className='oc-quantity-row'>
                            <span className='oc-quantity-label'>QUANTITY</span>
                            <div className='oc-quantity-controls'>
                                <button
                                    className='oc-qty-btn'
                                    onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                                >
                                    &minus;
                                </button>
                                <input
                                    className='oc-qty-input'
                                    type='number'
                                    min='1'
                                    value={quantity}
                                    onChange={(e) => {
                                        const val = parseInt(e.target.value, 10);
                                        if (val >= 1) setQuantity(val);
                                    }}
                                />
                                <button
                                    className='oc-qty-btn'
                                    onClick={() => setQuantity((q) => q + 1)}
                                >
                                    +
                                </button>
                            </div>
                        </div>

                        <button
                            className='oc-add-to-cart'
                            onClick={handleAddToCart}
                            disabled={!selectedSize}
                        >
                            {selectedSize ? 'ADD TO CART' : 'SELECT A SIZE'}
                        </button>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}
